import { DialogObject } from '@/components/dialog/dialog.types';
import { FormBuilderComponent } from '@/components/form-builder/form-builder.component';
import { DynamicForm } from '@/components/form-builder/form-builder.types';

interface getDacPreCreateDialogObjectProps {
  formObject: DynamicForm;
  action: () => void;
  toggleVisiblity?: () => void;
}

export const getDacPreCreateDialogObject = ({ formObject, action, toggleVisiblity }: getDacPreCreateDialogObjectProps): DialogObject => {
  return {
    title: `dac.createTitle`,
    description: 'Veuillez saisir les informations du DAC',
    component: {
      outlet: FormBuilderComponent,
      props: {
        formObject,
      },
    },
    actions: [
      {
        label: 'Procéder',
        variant: 'success',
        onClick: () => action?.(),
      },
      {
        label: 'Annuler',
        onClick: () => {
          toggleVisiblity?.();
        },
        variant: 'secondary',
      },
    ],
  };
};
